export const COUNTRY_KEY = "soko-country";
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
export const GRAPHQL_API_GATEWAY = process.env.REACT_APP_GRAPHQL_API_GATEWAY;
